/**
 * Toast Notification Component
 *
 * @package
 */

import { useEffect } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import Icon from './Icon';

const Toast = ( { message, type = 'success', onDismiss, duration = 3000 } ) => {
	useEffect( () => {
		if ( duration > 0 ) {
			const timer = setTimeout( () => {
				if ( onDismiss ) {
					onDismiss();
				}
			}, duration );

			return () => clearTimeout( timer );
		}
	}, [ duration, onDismiss ] );

	const typeClass = `configurator-toast-${ type }`;

	return (
		<div
			className={ `configurator-toast ${ typeClass }` }
			role="alert"
			aria-live="polite"
			aria-atomic="true"
		>
			<span className="configurator-toast-message">{ message }</span>
			{ onDismiss && (
				<button
					type="button"
					className="configurator-toast-close"
					onClick={ onDismiss }
					aria-label={ __( 'Close', 'at-vehicle-configurator' ) }
				>
					<span className="screen-reader-text">{ __( 'Close', 'at-vehicle-configurator' ) }</span>
					<Icon name="close" size="medium" />
				</button>
			) }
		</div>
	);
};

export default Toast;
